import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const LogoIntact = () => {
  return (
    <div>
      <h1>
        <StaticImage
          src="../images/logos/SRA-831b-logo.png"
          width={398}
          quality={95}
          formats={["AUTO", "WEBP", "AVIF"]}
          alt="SRA 831(b) ADMIN for Business Owners"
          className="w-2/3 md:w-full mx-auto"
          layout="fullWidth"
          loading="eager"
          placeholder="none"
        />
      </h1>
    </div>
  )
}

export default LogoIntact